<template>
    <div class="section-box received-payment">
        <el-row class="row-bg">
            <el-row>
                <el-col :span="24" style="text-align: left;line-height: 36px;"> 
                    <el-form :inline="false" label-width="75px" label-position="left">
                        <el-form-item label="状态:">
                            <el-badge :value="icon.a" style="margin-right: 25px;" :max="9999">
                                <el-button size="mini"  @click="chose(1)" :class="form.tag ==1 ?'selected':''">用户申请</el-button>
                            </el-badge>
                            <el-badge :value="icon.b" style="margin-right: 25px;" :max="9999">
                                <el-button size="mini"  @click="chose(2)" :class="form.tag ==2 ?'selected':''">后台申请</el-button>
                            </el-badge>
                            <el-badge :value="icon.c" style="margin-right: 25px;" :max="9999">
                                <el-button size="mini"  @click="chose(3)" :class="form.tag ==3 ?'selected':''">待回款</el-button>
                            </el-badge>
                            <el-badge :value="icon.d" style="margin-right: 25px;" :max="9999">
                                <el-button size="mini"  @click="chose(4)" :class="form.tag ==4 ?'selected':''">已完成</el-button>
                            </el-badge>
                            <el-badge :value="icon.e" style="margin-right: 25px;" :max="9999">
                                <el-button size="mini"  @click="chose(5)" :class="form.tag ==5 ?'selected':''">已拒绝</el-button>
                            </el-badge>
                            <el-badge :value="icon.f" style="margin-right: 25px;" :max="9999">
                                <el-button size="mini"  @click="chose(6)" :class="form.tag ==6 ?'selected':''">待作废</el-button>
                            </el-badge>
                          </el-form-item>
                         <el-form-item label="工单编号:">
                             <el-row>
                                  <el-col :span="4" style="text-align: right;"> 
                                      <el-input v-model="form.jobNo"   size="medium" width="180"></el-input>
                                  </el-col>
                                  <el-col :span="20" style="text-align: right;"> 
                                      <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                                      <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                                      <el-button size="medium" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
                                  </el-col>
                               </el-row>
                        </el-form-item>
                    </el-form>
                  </el-col>
           </el-row>
            <!-- <el-row>
                <el-col :span="12" style="text-align: left;">
                    <el-form :inline="true" label-width="75px" label-position="left">
                        <el-form-item label="工单编号:">
                             <el-input v-model="form.JobNo"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12" style="text-align: right;">
                    <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                    <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                    <el-button size="medium" type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
                </el-col>
             </el-row> -->
        </el-row>
   
        <!-- 列表 -->
        <el-table
            ref="tableData"
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="666"
            border
            v-loading="listLoading" 
            >
            <el-table-column label="发票Id">
                <el-table-column show-overflow-tooltip width="80">
                    <!-- <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.userName" placeholder="输入账户搜索" @blur="GetInvoiceList()"/>
                    </template> -->
                    <template slot-scope="scope">
                        <span>{{scope.row.id || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="申请时间" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.EffectivityTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <!-- eslint-disable  -->
            <!-- TIPS：在待回款、已完成的状态下显示 -->
            <el-table-column label="开票时间" > 
                <el-table-column show-overflow-tooltip width="190" >
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.invoiceTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{(scope.row.invoiceDt!='1900-01-01 00:00:00'?scope.row.invoiceDt:'') || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="账户">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.userName" placeholder="输入账户搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.userName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发票抬头" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.invoiceTitle" placeholder="输入发票抬头搜索" />
                    </template>
                    <template slot-scope="scope">
                        <img :src="icon_sandian" style="width: 15px;float: left;margin-top: 5px;" v-if="scope.row.isEInvoice==1">
                        <span>{{scope.row.invoiceTitle || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="开票状态" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.invoiceStatus" placeholder="请选择" style="width: 100%;">
                            <el-option :value="item.value" :label="item.name" v-for="(item, index) in invoiceStatusArray" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{toInvoiceStatusName(scope.row.invoiceStatus)  || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="开票选项">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.invoiceContentType" placeholder="请选择平台" style="width: 100%;">
                            <el-option value="0" label="请选择"></el-option>
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in invoiceContentOptionArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.invoiceContent || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="税点" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.taxPointId" placeholder="请选择平台" style="width: 100%;">
                            <el-option value="" label="请选择"></el-option>
                            <el-option :value="item.key" :label="item.value" v-for="(item, index) in taxPointOptionArr" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.taxPoint || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="开票金额">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.invoiceMoneyBegin" style="width: 45%;" placeholder="搜索" type="number"/> ~
                        <el-input size="mini" v-model="form.invoiceMoneyEnd" style="width: 45%;" placeholder="搜索" type="number"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.invoiceMoney}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="已收金额" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.receivedMoneyBegin" style="width: 45%;" placeholder="搜索" type="number"/> ~
                        <el-input size="mini" v-model="form.receivedMoneyEnd" style="width: 45%;" placeholder="搜索" type="number"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.receivedMoney}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="剩余应收金额" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.receivableMoneyBegin" style="width: 45%;" placeholder="搜索" type="number"/> ~
                        <el-input size="mini" v-model="form.receivableMoneyEnd" style="width: 45%;" placeholder="搜索" type="number"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.receivableMoney}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <!-- <el-table-column label="申请时间" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.EffectivityTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column> -->
                  <!-- TIPS：在待回款、已完成的状态下显示 -->
            <el-table-column label="发票编号" >
                <el-table-column show-overflow-tooltip width="250" >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.invoiceNumber" placeholder="输入发票编号搜索" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.invoiceNumber || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="回款时间" v-if="form.tag ==3 ||form.tag ==4" >
                <el-table-column show-overflow-tooltip width="180" >
                    <!-- <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.invoiceNumber" placeholder="回款时间" />
                    </template> -->
                    <template slot-scope="scope">
                        <span>{{scope.row.invoiceReturnPaymentsOpDt || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <!-- End -->
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="openInvoice(scope.row)">详情</el-button>
                </template>
            </el-table-column>
            
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNo"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <DetailsInvoice ref="detailsInvoice"/>
    </div>
</template>

<script>
import DetailsInvoice from './index/detailsInvoice'
import eventBus from "@/utils/eventBus.js";
import { 
  getStorageToken,
} from '@/utils/store'
import {
    invoiceManageList,invoiceManageCount,invoiceContentOption,taxPointOption,
} from "@/service/payApi";
import couponsIssueVue from '../coupons/couponsIssue.vue';
  export default {
    components: {
        DetailsInvoice
    },
    data() {
        return {
            icon_sandian: require('@/assets/icon/sd.png'),
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,
                jobNo:'',

                invoiceTime: [],        //开票时间
                EffectivityTime: [],    //时间
                invoiceContentType:"",
                invoiceMoneyBegin:"",
                invoiceMoneyEnd:"",
                invoiceTitle:"",
                receivableMoneyBegin:"",
                receivableMoneyEnd:"",
                receivedMoneyBegin:"",
                receivedMoneyEnd:"",
                taxPointId:"",
                userName:"",
                invoiceNumber: "",
                tag:1,
                isInvoice:false,
                invoiceStatus:-1
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数
            tableData:[],
            icon:{
                a:0,
                b:0,
                c:0,
                d:0,
                e:0,
                f:0
            },
            invoiceContentOptionArr:[
                {
                    label: "*研发和技术服务*技术服务费",
                    value: 1,
                },
                {
                    label: "*研发和技术服务*技术咨询费",
                    value: 2,
                },
                {
                    label: "*现代服务*技术服务费",
                    value: 3
                },
                {
                    label: "*现代服务*技术咨询费",
                    value: 4
                },
                {
                    label: "*现代服务*现场服务",
                    value: 5
                },
                {
                    label: "*现代服务*现场技术服务",
                    value: 6
                }
            ],
            taxPointOptionArr:[],
            invoiceStatusArray: [   
                        {name:'全部',value:-1},
                        {name:'开票中',value:0},
                        {name:'开票失败',value:8}
                    ]
        }
    },
    activated(){
        this.handleSearch()
        // this.getInvoiceContentOption()
        this.getTaxPointOption()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];

        var that=this;
        eventBus.$on("reloadInvoiceList", (data) => {
            console.log('调用reloadInvoiceList：'+data);
            that.GetInvoiceList();
        }); 
    }, 
    computed: {
    },
    watch:{
        
        'form.tag':function(newVal,oldVal){
            console.log('newVal:'+newVal);
               if(newVal==1||newVal==2){
                    this.invoiceStatusArray=
                    [   {name:'全部',value:-1},
                        {name:'开票中',value:0},
                        {name:'开票失败',value:8}
                    ];
               }
               else if(newVal==3)
               {
                this.invoiceStatusArray=
                    [   {name:'全部',value:-1},
                        {name:'待回款',value:5}
                    ];
               }
               else if(newVal==4)
               {
                this.invoiceStatusArray=
                    [   {name:'全部',value:-1},
                        {name:'已完成',value:3}
                    ];
               }
               else if(newVal==5)
               {
                this.invoiceStatusArray=
                    [   {name:'全部',value:-1},
                        {name:'已拒绝',value:4}
                    ];
               }
               else if(newVal==6)
               {
                this.invoiceStatusArray=
                    [   {name:'全部',value:-1},
                        {name:'待回款',value:5},
                        {name:'已完成',value:3}
                    ];
               }
        }
    },
    mounted() {
    },
    methods: {
        getTaxPointOption(){
                taxPointOption().then((r)=>{
                    if(r.Result != 1){
                        return this.$message.error(r.Message)
                    }
                    this.taxPointOptionArr = r.Data
                })
            },
        // getInvoiceContentOption(){
        //         invoiceContentOption().then((r)=>{
        //             if(r.Result != 1){
        //                 return this.$message.error(r.Message)
        //             }
        //             this.invoiceContentOptionArr = r.Data
        //         })
        //     },
        downloadFile() {
            const _this = this
            let data = {
                tag:this.form.tag,
            }
            if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.createTimeBegin = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.createTimeEnd = _this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.createTimeBegin) delete data.createTimeBegin;
                    if (data.createTimeEnd) delete data.createTimeEnd;
                }
            if (_this.form.invoiceTime instanceof Array &&_this.form.invoiceTime.length > 0) {
                    data.invoiceDtBegin = _this.form.invoiceTime[0] + " 00:00:00";
                    data.invoiceDtEnd = _this.form.invoiceTime[1] + " 23:59:59";
                } else {
                    if (data.invoiceDtBegin) delete data.invoiceDtBegin;
                    if (data.invoiceDtEnd) delete data.invoiceDtEnd;
                }
            if(this.form.invoiceContentType&&this.form.invoiceContentType>0) data.invoiceContentType = this.form.invoiceContentType
            if(this.form.invoiceMoneyBegin) data.invoiceMoneyBegin = this.form.invoiceMoneyBegin
            if(this.form.invoiceMoneyEnd) data.invoiceMoneyEnd = this.form.invoiceMoneyEnd
            if(this.form.invoiceTitle) data.invoiceTitle = this.form.invoiceTitle
            if(this.form.receivableMoneyBegin) data.receivableMoneyBegin = this.form.receivableMoneyBegin
            if(this.form.receivableMoneyEnd) data.receivableMoneyEnd = this.form.receivableMoneyEnd
            if(this.form.receivedMoneyBegin) data.receivedMoneyBegin = this.form.receivedMoneyBegin
            if(this.form.receivedMoneyEnd) data.receivedMoneyEnd = this.form.receivedMoneyEnd
            if(this.form.taxPointId) data.taxPointId = this.form.taxPointId
            if(this.form.userName) data.userName = this.form.userName
            if(this.form.invoiceNumber) data.invoiceNumber = this.form.invoiceNumber
            let url =
            process.env.NODE_ENV == "development" ?
            "/api2" :
            process.env.VUE_APP_API2;

            window.open(
            url + "/gz/admin/download/invoiceManage/download" + "?" + this.parseJsonURL(data)
            );
        },
        parseJsonURL(json) {
            if (!json) return "";
            if (typeof json == "string") return json;
            return this.cleanArray(
            Object.keys(json).map(function (key) {
                if (json[key] === undefined) return "";
                return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
            })
            ).join("&");
        },
        cleanArray(actual) {
        var newArray = [];
        for (var i = 0; i < actual.length; i++) {
          if (actual[i]) {
            newArray.push(actual[i]);
          }
         }
         return newArray;
       },
        chose(type){
            // this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.form.tag = type;
          
            console.log('this.form.tag:'+this.form.tag);
            this.form.PageNo = 1;
            this.form.PageSize = 10;
            this.GetInvoiceList();
        },
        getCount(){
            const _this = this
            let data = {
                // pageNum:this.form.PageNo,
                // pageSize:this.form.PageSize,
                rational:true,
                // tag:this.form.tag,
            }
            // !data.Name && delete data.Name
            data.Token = getStorageToken();
            data.platform = 'zyd'
             if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.createTimeBegin = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.createTimeEnd = _this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.createTimeBegin) delete data.createTimeBegin;
                    if (data.createTimeEnd) delete data.createTimeEnd;
                }
            if (_this.form.invoiceTime instanceof Array &&_this.form.invoiceTime.length > 0) {
                    data.invoiceDtBegin = _this.form.invoiceTime[0] + " 00:00:00";
                    data.invoiceDtEnd = _this.form.invoiceTime[1] + " 23:59:59";
                } else {
                    if (data.invoiceDtBegin) delete data.invoiceDtBegin;
                    if (data.invoiceDtEnd) delete data.invoiceDtEnd;
                }
            if(this.form.invoiceContentType&&this.form.invoiceContentType>0) data.invoiceContentType = this.form.invoiceContentType
            if(this.form.invoiceMoneyBegin) data.invoiceMoneyBegin = this.form.invoiceMoneyBegin
            if(this.form.invoiceMoneyEnd) data.invoiceMoneyEnd = this.form.invoiceMoneyEnd
            if(this.form.invoiceTitle) data.invoiceTitle = this.form.invoiceTitle
            if(this.form.receivableMoneyBegin) data.receivableMoneyBegin = this.form.receivableMoneyBegin
            if(this.form.receivableMoneyEnd) data.receivableMoneyEnd = this.form.receivableMoneyEnd
            if(this.form.receivedMoneyBegin) data.receivedMoneyBegin = this.form.receivedMoneyBegin
            if(this.form.receivedMoneyEnd) data.receivedMoneyEnd = this.form.receivedMoneyEnd
            if(this.form.taxPointId) data.taxPointId = this.form.taxPointId
            if(this.form.userName) data.userName = this.form.userName
            if(this.form.invoiceNumber) data.invoiceNumber = this.form.invoiceNumber
            invoiceManageCount(data).then((r)=>{
                if(r.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
                }
                var temp = r.Data
                for(var i=0;i<temp.length;i++){
                    if(temp[i].tag == 1){
                        this.icon.a = temp[i].count
                    }
                    if(temp[i].tag == 2){
                        this.icon.b = temp[i].count
                    }
                    if(temp[i].tag == 3){
                        this.icon.c = temp[i].count
                    }
                    if(temp[i].tag == 4){
                        this.icon.d = temp[i].count
                    }
                    if(temp[i].tag == 5){
                        this.icon.e = temp[i].count
                    }
                    if(temp[i].tag == 6){
                        this.icon.f = temp[i].count
                    }
                }
            })
        },
        //渲染列表
        handleSearch() {
            // this.searchData = Object.assign({}, this.form)
            this.GetInvoiceList()
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNo = val
            this.searchData.PageNo = val
            this.GetInvoiceList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageNo = 1
            this.form.PageSize = val
            this.searchData.PageNo = 1
            this.searchData.PageSize = val
            this.GetInvoiceList()
        },
        // TODO：修改接口名 form参数 table展示数据
        async GetInvoiceList(){
            const _this = this
            this.listLoading = true
            // let data = JSON.parse(JSON.stringify(this.searchData))
            let data = {
                pageNum:this.form.PageNo,
                pageSize:this.form.PageSize,
                rational:true,
                tag:this.form.tag 
            }
            // !data.Name && delete data.Name
            data.Token = getStorageToken();
            data.platform = 'zyd'
             if (_this.form.EffectivityTime instanceof Array &&_this.form.EffectivityTime.length > 0) {
                    data.createTimeBegin = _this.form.EffectivityTime[0] + " 00:00:00";
                    data.createTimeEnd = _this.form.EffectivityTime[1] + " 23:59:59";
                } else {
                    if (data.createTimeBegin) delete data.createTimeBegin;
                    if (data.createTimeEnd) delete data.createTimeEnd;
                }
            if (_this.form.invoiceTime instanceof Array &&_this.form.invoiceTime.length > 0) {
                    data.invoiceDtBegin = _this.form.invoiceTime[0] + " 00:00:00";
                    data.invoiceDtEnd = _this.form.invoiceTime[1] + " 23:59:59";
                } else {
                    if (data.invoiceDtBegin) delete data.invoiceDtBegin;
                    if (data.invoiceDtEnd) delete data.invoiceDtEnd;
                }
            if(this.form.invoiceContentType&&this.form.invoiceContentType>0) data.invoiceContentType = this.form.invoiceContentType
            if(this.form.invoiceMoneyBegin) data.invoiceMoneyBegin = this.form.invoiceMoneyBegin
            if(this.form.invoiceMoneyEnd) data.invoiceMoneyEnd = this.form.invoiceMoneyEnd
            if(this.form.invoiceTitle) data.invoiceTitle = this.form.invoiceTitle
            if(this.form.receivableMoneyBegin) data.receivableMoneyBegin = this.form.receivableMoneyBegin
            if(this.form.receivableMoneyEnd) data.receivableMoneyEnd = this.form.receivableMoneyEnd
            if(this.form.receivedMoneyBegin) data.receivedMoneyBegin = this.form.receivedMoneyBegin
            if(this.form.receivedMoneyEnd) data.receivedMoneyEnd = this.form.receivedMoneyEnd
            if(this.form.taxPointId) data.taxPointId = this.form.taxPointId
            if(this.form.userName) data.userName = this.form.userName
            if(this.form.invoiceNumber) data.invoiceNumber = this.form.invoiceNumber
            if(this.form.invoiceStatus>-1) data.invoiceStatus = this.form.invoiceStatus
            if(this.form.jobNo) data.jobNo = this.form.jobNo

            console.log('form.invoiceStatus:'+this.form.invoiceStatus);
            console.log('data.invoiceStatus:'+data.invoiceStatus);
            let res = await invoiceManageList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.datas
       
            this.total = res.Data.total
            this.getCount()
            this.$nextTick(()=>{
            this.$refs.tableData.doLayout()
            })
        },

        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
        // 点击详情
        openInvoice(row){
            this.$refs.detailsInvoice.open(row,this.form.tag)
        },

        toInvoiceStatusName(invoiceStatus){
            var str=invoiceStatus;
            if(invoiceStatus==0){
                str='开票中';
            }
            else if(invoiceStatus==3){
                str='已完成';
            }
            else if(invoiceStatus==4){
                str='已拒绝';
            } 
            else if(invoiceStatus==5){
                str='待回款';
            } 
            else if(invoiceStatus==7){
                str='后台已开票未付款';
            }
            else if(invoiceStatus==8){
                str='开票失败';
            }
            return str;
        }
 
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
    .received-payment {
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
</style>